/** One hop from a save response: the id used in the PUT → backend `newTransactionId`. */
export type DrawerTransactionIdHop = {
  fromTransactionId: string;
  toTransactionId: string;
};

/**
 * Walk old→new hops until the latest id (cycle-safe).
 * Drawer form uuids stay open-time; only the save path resolves through this map.
 */
export function resolveDrawerTransactionId(
  transactionId: string,
  map: Record<string, string> | null | undefined
): string {
  const start = String(transactionId ?? '').trim();
  if (!start || !map) return start || String(transactionId ?? '');

  let current = start;
  const visited = new Set<string>();
  while (Object.prototype.hasOwnProperty.call(map, current)) {
    if (visited.has(current)) break;
    visited.add(current);
    const next = String(map[current] ?? '').trim();
    if (!next) break;
    current = next;
  }
  return current;
}

/** Append new hops without rewriting earlier history (A→B stays; add B→C). */
export function appendDrawerTransactionIdHops(
  map: Record<string, string> | null | undefined,
  hops: DrawerTransactionIdHop[]
): Record<string, string> {
  const next: Record<string, string> = { ...(map ?? {}) };
  for (const hop of hops) {
    const from = String(hop.fromTransactionId ?? '').trim();
    const to = String(hop.toTransactionId ?? '').trim();
    if (!from || !to || from === to) continue;
    next[from] = to;
  }
  return next;
}
